export default "__VITE_ASSET__DBxsv4xf__"